export default __webpack_public_path__ + "static/media/TINY-AWAY-QUIET-LAKE-HOUSE-SJL-Photography-00006-667x500.5bf87315.jpg";